import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';

const STORAGE_KEY = 'yalla_lang';

function applyDirAndLang(lng) {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
}

const savedLng = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
const initialLng = savedLng === 'ar' || savedLng === 'en' ? savedLng : 'en';
applyDirAndLang(initialLng);

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ar: { translation: ar } },
    lng: initialLng,
    fallbackLng: 'en',
    react: { useSuspense: false },
  });

i18n.on('languageChanged', (lng) => {
  applyDirAndLang(lng);
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
